import {z} from 'zod';

import {LeadQualityEnumSchema} from '@dms/api/shared';

// Schemas
export const ChangeLeadQualityRequestBodySchema = z.object({
  leadQuality: LeadQualityEnumSchema,
});

export const ChangeBusinessCaseLeadQualityApiArgSchema = z.object({
  businessCaseId: z.string(),
  changeLeadQualityRequestBody: ChangeLeadQualityRequestBodySchema,
});

export const ChangeInterestLeadQualityApiArgSchema = z.object({
  interestId: z.string(),
  changeLeadQualityRequestBody: ChangeLeadQualityRequestBodySchema,
});

export const LeadQualityResponseBodySchema = z.object({
  value: z.string(),
  color: z.string(),
  label: z.string(),
});

export type ChangeBusinessCaseLeadQualityApiResponse = /** status 204  */ z.infer<
  typeof ChangeBusinessCaseLeadQualityApiResponseSchema
>;
export type ChangeBusinessCaseLeadQualityApiArg = z.infer<
  typeof ChangeBusinessCaseLeadQualityApiArgSchema
>;
export type ChangeInterestLeadQualityApiResponse = /** status 204  */ z.infer<
  typeof ChangeInterestLeadQualityApiResponseSchema
>;
export type ChangeInterestLeadQualityApiArg = z.infer<typeof ChangeInterestLeadQualityApiArgSchema>;
export const ChangeBusinessCaseLeadQualityApiResponseSchema = z.void();
export type GetLeadQualityOptionsApiResponse = z.infer<
  typeof GetLeadQualityOptionsApiResponseSchema
>;
export const ChangeInterestLeadQualityApiResponseSchema = z.void();
// For GetLeadQualityOptionsApiResponse, which is an array of LeadQualityResponseBody
export const GetLeadQualityOptionsApiResponseSchema = z.array(LeadQualityResponseBodySchema);
